import { render, staticRenderFns } from "./SettingsIntegrationCreate.vue?vue&type=template&id=4bd40486&"
import script from "./SettingsIntegrationCreate.vue?vue&type=script&lang=js&"
export * from "./SettingsIntegrationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports